<a routerLink="/" *puLet="logo$ | async as logo">
  <svg>
    <use [attr.xlink:href]="logo" [attr.href]="logo"></use>
  </svg>
</a>
